// Menu lateral: grupos e submenus que dobram, item ativo, filete indicador, grupos fechados lembrados.
// Markup: menu/menu.blade.php (#o_nav). jQuery vem global do Metronic.
const $ = window.jQuery;
const Dobra = require('./Dobra');
const NavScroll = require('./NavScroll');

const SidebarNav = function () {

    const KEY = 'one-menu-fechados';
    let nav = null, indicador = null;

    const lerFechados = function () {
        try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
    };

    const gravarFechados = function (o) {
        try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {}
    };

    const mover = function (el) {
        if (!el) { indicador.dataset.visible = 'false'; return; }
        const a = el.getBoundingClientRect(), b = nav.getBoundingClientRect();
        if (!a.height) { indicador.dataset.visible = 'false'; return; }
        indicador.dataset.visible = 'true';
        indicador.style.height = a.height + 'px';
        indicador.style.transform = 'translateY(' + (a.top - b.top + nav.scrollTop) + 'px)';
    };

    const posicionar = function () {
        mover(nav.querySelector('.nav-item[aria-current="page"]'));
    };

    // depois da animação da dobra: refaz o filete e a barra de rolagem
    const reposicionar = function () {
        [260, 400].forEach(t => setTimeout(() => { posicionar(); NavScroll.atualizar(); }, t));
    };

    // grupos fechados lembrados no navegador
    const restaurarGrupos = function () {
        const fechados = lerFechados();
        $(nav).find('.nav-section[data-grupo]').each(function () {
            if (!fechados[this.dataset.grupo]) return;
            $(this).siblings('.nav-corpo')[0].dataset.dobrada = 'true';
            this.setAttribute('aria-expanded', 'false');
        });
        Dobra.numerar(nav);
    };

    // item ativo = o link igual à URL da página; abre o submenu/grupo que o contém
    const marcarAtivo = function () {
        const atual = $(nav).data('url_current');
        const $ativo = $(nav).find('a.nav-item[href]').filter((i, a) => a.getAttribute('href') === atual).first();
        if (!$ativo.length) return;
        $ativo.attr('aria-current', 'page');
        const sub = $ativo.closest('.submenu')[0];
        if (sub) {
            sub.dataset.dobrada = 'false';
            $(sub).siblings('.nav-item').attr('aria-expanded', 'true');
        }
        const corpo = $ativo.closest('.nav-corpo')[0];
        if (corpo && corpo.dataset.dobrada === 'true') {
            corpo.dataset.dobrada = 'false';
            $(corpo).siblings('.nav-section').attr('aria-expanded', 'true');
        }
    };

    const alternarGrupo = function () {
        const corpo = $(this).siblings('.nav-corpo')[0];
        const fechando = corpo.dataset.dobrada !== 'true';
        Dobra.alternar(corpo, !fechando);
        this.setAttribute('aria-expanded', fechando ? 'false' : 'true');
        const mapa = lerFechados();
        if (fechando) mapa[this.dataset.grupo] = true; else delete mapa[this.dataset.grupo];
        gravarFechados(mapa);
        reposicionar();
    };

    const alternarSubmenu = function () {   // botão pai de um submenu
        const sub = $(this).siblings('.submenu')[0];
        if (!sub) return;
        const fechando = sub.dataset.dobrada !== 'true';
        Dobra.alternar(sub, !fechando);
        this.setAttribute('aria-expanded', fechando ? 'false' : 'true');
        reposicionar();
    };

    return {
        init: function () {
            const $nav = $('#o_nav');
            if (!$nav.length) return;
            nav = $nav[0];
            indicador = $nav.find('.nav-indicator')[0];

            restaurarGrupos();
            marcarAtivo();

            $nav.on('click', '.nav-section[data-grupo]', alternarGrupo);
            $nav.on('click', 'button.nav-item', alternarSubmenu);
            window.addEventListener('resize', posicionar);

            setTimeout(posicionar, 0);
            NavScroll.init(nav);
        },
        posicionar: posicionar
    };
}();

module.exports = SidebarNav;
